import React, {useEffect, useRef, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import UserSearch from "../../components/UserSearch";
import filtrosAcontecimentoStyle from "../../assets/jss/material-dashboard-pro-react/components/filtrosAcontecimentoStyle";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilter, faSearch} from "@fortawesome/free-solid-svg-icons";
import connection from "../../connection";
import Select, {createFilter} from 'react-select';
import Switch from "@material-ui/core/Switch";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "../DatetimeWrapper";
import StateCircle from "../StateCircle";
import "./styles.scss";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import CustomInput from "../CustomInput/CustomInput";
import Button from "../CustomButtons/Button.jsx";

const filtrosAcontecimentoContext = React.createContext({});

const ProviderFiltrosAcontecimento = (props) => {
  const [showSearch, setShowSearch] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filtroSearch, setFiltroSearch] = useState("");
  const [filtrosAplicados, setFiltrosAplicados] = useState({});

  let filtros_disponiveis = {
    regiao: [],
    nucleo: [],
    agrupamento: [],
    fase: [],
    estado_acontecimento: [],
    modulo: null,
    diretor: null,
    data_desde: null,
    data_ate: null,
    enriquecimento: false,
    formacao_continua: false,
    tipo_utilizador: null,
    mostrar_inativos: false
  }

  let aplicar_filtros = {}

  useEffect(() => {
    for (let key in filtros_disponiveis) {
      if (props.lista_filtros && props.lista_filtros.includes(key))
        aplicar_filtros[key] = props.defaultFilters?.[key] || filtros_disponiveis[key];

      let filtros = {...aplicar_filtros};
      setFiltrosAplicados(filtros)
    }
  }, []);

  const [filtroFilters, setFiltroFilters] = useState(aplicar_filtros);

  useEffect(() => {
    props.atualizar && props.atualizar(filtroFilters, filtroSearch);
  }, [filtroFilters, filtroSearch]);

  useEffect(() => {
    props.filterActive && props.filterActive(showFilters)
  }, [showFilters]);

  let values = {
    showSearch,
    setShowSearch,
    showFilters,
    setShowFilters,
    filtroSearch,
    setFiltroSearch,
    filtroFilters,
    setFiltroFilters,
    filtrosAplicados,
    props
  }

  return <filtrosAcontecimentoContext.Provider value={values}>
    {props.children}
  </filtrosAcontecimentoContext.Provider>
}

const useFiltrosAcontecimento = () => React.useContext(filtrosAcontecimentoContext);

const Filtro = (props) => {
  const labelRef = useRef(null);
  const contentRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props.focusOnOpen && open && contentRef.current)
      contentRef.current.getElementsByTagName("input")[0]?.focus();

  }, [open]);

  return <div className={"filtro"}>
    <span className={"filtro_label" + (open ? " open" : "")} ref={labelRef} onClick={() => setOpen(!open)}>
      <span className={props.isActive ? "active" : ""}>{props.label || "Filtro"}</span>
      </span>
    <Popper
      open={open}
      anchorEl={labelRef.current}
      transition
      disablePortal
      placement="bottom-start"
    >
      {(popperProps) => (
        <div {...popperProps}>
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div ref={contentRef}>
              {props.children}
            </div>
          </ClickAwayListener>
        </div>
      )}
    </Popper>
  </div>
}

const CaixaFiltrosAcontecimento = (props) => {
  const {showFilters, props: {acontecimento, percurso, pagina, separador}, setFiltroFilters, filtroFilters, filtrosAplicados} = useFiltrosAcontecimento();
  const classes = {};

  if (!showFilters)
    return null;

  const selectClasses = {
    option: state => "option " + state.data.tipo,
    menu: state => "menu",
    control: state => "control",
    indicatorsContainer: () => "indicatorsContainer"
  };

  const mudarFiltro = (tipo, valor, adicionar = true) => {
    let novo_filtro = {...filtroFilters};

    if (adicionar) {
      switch (tipo) {
        case 'mostrar_inativos':
        case 'enriquecimento':
        case 'formacao_continua':
        case 'data_desde':
        case 'data_ate':
        case 'diretor':
          novo_filtro[tipo] = valor;
          break;
      }
    } else {
      novo_filtro[tipo] = novo_filtro[tipo].filter(v => v !== valor);
    }

    setFiltroFilters(novo_filtro);
  }

  // Variáveis para guardar lista regiões, núcleos e agrupamentos
  let [regioes, setRegioes] = useState([]);
  let [nucleos, setNucleos] = useState([]);
  let [agrupamentos, setAgrupamentos] = useState([]);

  // Variáveis para guardar lista de estados do percurso
  let [fasesPercurso, setFasesPercurso] = useState([]);

  // Variáveis de filtros de estado do acontecimento
  let [estadosAcontecimento, setEstadosAcontecimento] = useState([]);

  // Variáveis de filtros de módulos
  let [modulos, setModulos] = useState([]);

  // Variáveis de filtros de tipo de utilizador
  let [tiposUtilizador, setTiposUtilizador] = useState([]);

  const obterDados = async () => {

    let locais = await connection.get("locais/filtragem");

    setRegioes(locais.regioes);

    if (!['secretarios_regionais'].includes(pagina))
      setNucleos(locais.nucleos);

    if (!['secretarios_nucleo', 'secretarios_regionais'].includes(pagina))
      setAgrupamentos(locais.agrupamentos);

    if (acontecimento === 'percurso')
      setFasesPercurso(await connection.get("percurso/fases/filtragem", {percurso: percurso.id}));

    if (acontecimento === 'formacao') {
      setEstadosAcontecimento(await connection.get("estados_acontecimento/filtragem", {acontecimento: "formacao"}));
      setModulos(await connection.get("modulos/filtragem"));
    }

    // Filtros de tipo de utilizadores só estão a ser aplicados nas páginas outros_cargos e cargos_temporarios
    if (acontecimento === 'utilizadores' && ["cargos_temporarios", "outros", "adultos"].includes(separador)) {
      setTiposUtilizador(await connection.get("utilizador/tipo/listagem", {separador: separador}));
    }
  }

  const filtroAlterado = (tipo) => {
    if (!Array.isArray(tipo))
      tipo = [tipo];
    return (value) => {
      let valores_filtro = {};
      if (Array.isArray(value)) {
        for (let v of value) {
          if (!valores_filtro[v.tipo])
            valores_filtro[v.tipo] = [];
          valores_filtro[v.tipo].push(v.value);
        }
      } else {
        valores_filtro[value?.tipo || tipo] = value?.value;
      }

      for (let t of tipo)
        delete filtroFilters[t];
      setFiltroFilters({...filtroFilters, ...valores_filtro});
    }
  }

  useEffect(() => {
    obterDados();
  }, []);

  const localOptions = [
    {
      label: "Regiões",
      options: regioes
    },
    {
      label: "Núcleos",
      options: nucleos
    },
    {
      label: "Agrupamentos",
      options: agrupamentos
    }
  ];

  return <div style={{width: "100%", zIndex: 14}} className={classes.filtros + " CaixaFiltrosAcontecimento"}>
    {(filtrosAplicados.hasOwnProperty("regiao") && filtrosAplicados.hasOwnProperty("nucleo") && filtrosAplicados.hasOwnProperty("agrupamento")) && <Filtro
      label={"Local"}
      isActive={(filtroFilters.nucleo?.length > 0 || filtroFilters.regiao?.length > 0 || filtroFilters.agrupamento?.length > 0)}
      focusOnOpen
    >
      <Select
        className={"filtro_select multiple " + (acontecimento === 'percurso' ? classes.local_percurso : classes.local_formacao)}
        closeMenuOnSelect={false}
        placeholder={"Região, núcleo ou agrupamento"}
        isMulti
        isClearable={false}
        value={[
          ...regioes.filter(l => filtroFilters.regiao?.includes(l.value)),
          ...nucleos.filter(l => filtroFilters.nucleo?.includes(l.value)),
          ...agrupamentos.filter(l => filtroFilters.agrupamento?.includes(l.value))
        ]}
        menuIsOpen={true}
        options={localOptions}
        classNames={selectClasses}
        onChange={filtroAlterado(['regiao', 'agrupamento', 'nucleo'])}
      />
    </Filtro>}
    {filtrosAplicados.hasOwnProperty("fase") && <Filtro
      label={"Fase"}
      isActive={(filtroFilters.fase?.length > 0)}
      focusOnOpen
    >
      <Select
        className={"filtro_select multiple " + classes.fase}
        closeMenuOnSelect={false}
        placeholder={"Fases do Percurso"}
        isMulti
        isClearable={false}
        value={[...fasesPercurso.filter(l => filtroFilters.fase?.includes(l.value))]}
        menuIsOpen={true}
        options={fasesPercurso}
        classNames={selectClasses}
        onChange={filtroAlterado('fase')}
      />
    </Filtro>}

    {filtrosAplicados.hasOwnProperty("estado_acontecimento") && <Filtro
      label={"Estado"}
      isActive={(filtroFilters.estado_acontecimento?.length > 0)}
      focusOnOpen
    >
      <Select
        className={"filtro_select multiple " + classes.estado_acontecimento}
        closeMenuOnSelect={false}
        placeholder={"Estados do Acontecimento"}
        isMulti
        isClearable={false}
        value={[...estadosAcontecimento.filter(l => filtroFilters.estado_acontecimento?.includes(l.value))]}
        menuIsOpen={true}
        options={estadosAcontecimento}
        classNames={selectClasses}
        onChange={filtroAlterado('estado_acontecimento')}
        getOptionLabel={option => <><StateCircle state={option.label}/>{option.label.designation}</>}
        filterOption={createFilter({
          stringify: option => option.data.label.designation
        })}
      />
    </Filtro>}

    {filtrosAplicados.hasOwnProperty("tipo_utilizador") && <Filtro
      label={"Tipo Utilizador"}
      isActive={(filtroFilters.tipo_utilizador)}
      focusOnOpen
    >
      <Select
        className={"filtro_select " + classes.tipo_utilizador}
        closeMenuOnSelect={false}
        placeholder={"Tipo Utilizador"}
        isClearable={true}
        value={[...tiposUtilizador.filter(l => filtroFilters.tipo_utilizador === l.value)]}
        menuIsOpen={true}
        options={tiposUtilizador}
        classNames={{
          option: state => "option " + state.data.tipo,
          menu: state => "menu",
          control: state => "control",
        }}
        onChange={filtroAlterado('tipo_utilizador')}
      />
    </Filtro>}

    {filtrosAplicados.hasOwnProperty("modulo") && <Filtro
      label={"Módulo"}
      isActive={(filtroFilters.modulo)}
      focusOnOpen
    >
      <Select
        className={"filtro_select " + classes.modulo}
        closeMenuOnSelect={false}
        placeholder={"Módulo"}
        isClearable={true}
        value={[...modulos.filter(l => filtroFilters.modulo === l.value)]}
        menuIsOpen={true}
        options={modulos}
        classNames={{
          option: state => "option " + state.data.tipo,
          menu: state => "menu",
          control: state => "control",
        }}
        onChange={filtroAlterado('modulo')}
      />
    </Filtro>}

    <div className={classes.cardDiretor}>
      {filtrosAplicados.hasOwnProperty("diretor") && <Filtro
        label={"Formador"}
        isActive={(filtroFilters.diretor)}
        focusOnOpen
      >
        <form autoComplete="off">
          <UserSearch
            labelText="NIN ou Email do Utilizador"
            id="userIdImpersonate"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "user_id"
            }}
            onFoundUser={(user) => {
              mudarFiltro("diretor", user.id)
            }}
            onUserNotFound={() => {
              mudarFiltro("diretor", null)
            }}
          />
        </form>
      </Filtro>}
    </div>

    {(filtrosAplicados.hasOwnProperty("data_desde") || filtrosAplicados.hasOwnProperty("data_ate")) && <Filtro
      label={"Data de início"}
      isActive={(filtroFilters.data_desde || filtroFilters.data_ate)}
    >
      {filtrosAplicados.hasOwnProperty("data_desde") && <FormControl fullWidth
                                                                     className={"filtro_select " + classes.data_desde}
      >
        <InputLabel shrink={true} className={classes.selectLabel}>
          Formações que se iniciem a partir de:
        </InputLabel>
        <Datetime
          onChange={(value) => {
            mudarFiltro("data_desde", value);
          }}
          dateFormat={"DD/MM/YYYY"}
          timeFormat={false}
          defaultValue={filtroFilters.data_desde}
        />
      </FormControl>}
      {filtrosAplicados.hasOwnProperty("data_ate") && <FormControl fullWidth
                                                                   className={"filtro_select " + classes.data_desde}
      >
        <InputLabel shrink={true} className={classes.selectLabel}>
          Formações que se iniciem até:
        </InputLabel>
        <Datetime
          onChange={(value) => {
            mudarFiltro("data_ate", value);
          }}
          dateFormat={"DD/MM/YYYY"}
          timeFormat={false}
          defaultValue={filtroFilters.data_ate}
        />
      </FormControl>}
    </Filtro>}

    {(filtrosAplicados.hasOwnProperty("enriquecimento") || filtrosAplicados.hasOwnProperty("formacao_continua")) && <Filtro
      label={"Outros"}
      isActive={(filtroFilters.enriquecimento || filtroFilters.formacao_continua)}
    >
      {filtrosAplicados.hasOwnProperty("enriquecimento") && <FormGroup className={classes.formGroup}>
        <FormControlLabel
          className={classes.formControlLabel}
          control={<Switch size="small" checked={filtroFilters.enriquecimento}
                           onChange={(event) => {
                             mudarFiltro("formacao_continua", false)
                             mudarFiltro("enriquecimento", event.target.checked)
                           }} color="primary"/>}
          label="Apenas Enriquecimento"
        />
      </FormGroup>}
      {filtrosAplicados.hasOwnProperty("formacao_continua") && <FormGroup className={classes.formGroup}>
        <FormControlLabel
          className={classes.formControlLabel}
          control={<Switch size="small" checked={filtroFilters.formacao_continua}
                           className={classes.switch}
                           onChange={(event) => {
                             mudarFiltro("enriquecimento", false)
                             mudarFiltro("formacao_continua", event.target.checked)
                           }} color="primary"/>}
          label="Apenas Formação Continua"
        />
      </FormGroup>}
    </Filtro>}

    {(filtrosAplicados.hasOwnProperty("mostrar_inativos")) && <Filtro
      label={"Mostrar Inativos"}
      isActive={false}
    >
      <FormGroup className={classes.formGroup}>
        <FormControlLabel
          className={classes.formControlLabel}
          control={<Switch size="small" checked={filtroFilters.enriquecimento}
                           onChange={(event) => {
                             mudarFiltro("mostrar_inativos", event.target.checked)
                           }} color="primary"/>}
          label="Mostrar Inativos"
        />
      </FormGroup>
    </Filtro>}
  </div>
}

const WidgetsFiltrosAcontecimento = (props) => {
  const classes = {};
  const {showSearch, setShowSearch, filtroSearch, setFiltroSearch, showFilters, setShowFilters, filtroFilters, props: setFilterActive} = useFiltrosAcontecimento();
  const searchRef = useRef(null);

  // Verificar se há algum filtro activo
  let filterIsActive = !!Object.keys(filtroFilters).find(f => {
    if (Array.isArray(filtroFilters[f]) && filtroFilters[f].length > 0 || !Array.isArray(filtroFilters[f]) && filtroFilters[f])
      return true;
  })

  // Verificar se há algum filtro activo na barra de pesquisar
  let searchIsActive = filtroSearch.length > 0;

  useEffect(() => {
    if (searchRef.current)
      searchRef.current.getElementsByTagName("input")[0].focus();
  }, [showSearch]);

  return <div className={"WidgetsFiltrosAcontecimento"}>
    <div className={"searchContent" + (showSearch ? " active" : "")}>
      {showSearch && <CustomInput
        formControlProps={{
          className: classes.searchInput
        }}
        inputProps={{
          type: "text",
          placeholder: "Pesquisar",
          onChange: (e) => {
            setFiltroSearch(e.target.value)
          },
          ref: searchRef
        }}
      />}
      <Button
        justIcon
        round
        simple
        onClick={() => {
          setShowSearch(!showSearch)
          setShowFilters(false)
          setFilterActive(false)
        }}
        style={{margin: 0}}
        color="info"
      >
        <span className={searchIsActive ? "active" : ""}>
          <FontAwesomeIcon icon={faSearch}/>
        </span>
      </Button>
    </div>

    <div className={"toggle_filtro " + (showFilters ? "active" : "")}>
      <Button
        justIcon
        round
        simple
        onClick={() => {
          setShowFilters(!showFilters)
          setShowSearch(false)
        }}
        style={{margin: 0}}
        color="info"
      >
        <span className={filterIsActive ? "active" : ""}>
          <FontAwesomeIcon icon={faFilter}/>
        </span>
      </Button>
    </div>
  </div>

}

export {WidgetsFiltrosAcontecimento, ProviderFiltrosAcontecimento, useFiltrosAcontecimento};

export default withStyles(filtrosAcontecimentoStyle)(CaixaFiltrosAcontecimento);
